import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref, reactive, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { groupInfoAddOrUpdate } from '../api.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateCollectiveDialog',
  props: {
    visible: { type: Boolean },
    deptTree: null
  },
  emits: ['update:visible', 'created'],
  setup(__props: any, { emit }) {

const props = __props as {
  visible: boolean,
  deptTree: Array<any>
};





const dialogVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value)
});

const form = reactive({
  deptId: '',
  groupName: ''
});

const handleClose = () => {
  dialogVisible.value = false;
  form.deptId = '';
  form.groupName = '';
};

const handleSubmit = () => {
  if (!form.deptId || !form.groupName) {
    ElMessage.warning('请填写完整信息');
    return;
  }
  groupInfoAddOrUpdate(form)
    .then(response => {
      console.log(response)
      emit('created');
      handleClose();
    })
};

return (_ctx: any,_cache: any) => {
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "创建团体",
    modelValue: _unref(dialogVisible),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : null)),
    width: "30%",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, { onClick: handleClose }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: form,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "归属机构" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tree_select, {
                modelValue: form.deptId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.deptId) = $event)),
                data: __props.deptTree,
                placeholder: "请选择归属机构",
                "check-strictly": "",
                clearable: "",
                "render-after-expand": false,
                style: {"width":"100%"}
              }, null, 8, ["modelValue", "data"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "团体名称" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.groupName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.groupName) = $event)),
                placeholder: "请输入团体名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})